import React, { useState } from 'react';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
const FAQS = [{
  question: '¿Necesito experiencia previa?',
  answer: 'No. El sistema fue pensado para personas que quieren empezar desde cero.'
}, {
  question: '¿Esto es solo teoría?',
  answer: 'No. Está orientado a que entiendas y puedas aplicar lo aprendido paso a paso.'
}, {
  question: '¿Voy a aprender a configurar el acceso remoto?',
  answer: 'Sí. Ese tema está incluido dentro del Tomo 3.'
}, {
  question: '¿Voy a ver instalaciones reales?',
  answer: 'Sí. Tenés un bono completo con instalaciones reales explicadas paso a paso.'
}, {
  question: '¿Me va a servir para empezar a trabajar de esto?',
  answer: 'Sí. Además del contenido técnico, tenés un tomo dedicado a cómo ganar dinero instalando cámaras y un bono específico para conseguir tus primeros clientes.'
}, {
  question: '¿Me ayuda a saber qué comprar?',
  answer: 'Sí. El Bono 1 está hecho justamente para eso.'
}, {
  question: '¿Los bonos vienen incluidos?',
  answer: 'Sí. Los 3 bonos están incluidos dentro de la oferta.'
}, {
  question: '¿Cómo accedo al contenido?',
  answer: 'Recibís acceso al producto una vez realizada la compra. Ahí podés completar con tu método de entrega o plataforma.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-[#0a1628] py-16 md:py-24 px-4 relative" data-id="element-44">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-45">
        <div className="flex justify-center mb-6" data-id="element-46">
          <div className="w-16 h-16 bg-blue-900/30 rounded-full flex items-center justify-center border border-blue-500/20" data-id="element-47">
            <HelpCircleIcon className="w-8 h-8 text-blue-400" data-id="element-48" />
          </div>
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-center text-white mb-12 uppercase drop-shadow-sm" data-id="element-49">
          PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-50">
          {FAQS.map((faq, index) => <div key={index} className="border border-blue-900/30 rounded-xl overflow-hidden transition-all duration-300 bg-[#0d1b2a] hover:border-blue-500/40 shadow-sm" data-id="element-51">
              <button className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none relative" onClick={() => toggleFAQ(index)} data-id="element-52">
                {/* Blue accent line on the left */}
                <div className={`absolute left-0 top-0 bottom-0 w-1 transition-colors duration-300 ${openIndex === index ? 'bg-blue-500' : 'bg-blue-900/50'}`} data-id="element-53"></div>

                <span className={`font-bold text-lg transition-colors duration-300 pl-2 ${openIndex === index ? 'text-blue-300' : 'text-white'}`} data-id="element-54">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 transform transition-transform duration-300 flex-shrink-0 ml-4 ${openIndex === index ? 'rotate-180 text-blue-400' : 'text-gray-500'}`} data-id="element-55" />
              </button>

              <div className={`overflow-hidden transition-all duration-300 ease-in-out bg-[#0a1628] ${openIndex === index ? 'max-h-40 opacity-100 border-t border-blue-900/30' : 'max-h-0 opacity-0'}`} data-id="element-56">
                <p className="text-gray-300 text-base md:text-lg p-6 pl-8" data-id="element-57">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}